<template>
  <div class="mt-4 column-types">
    <ContactPopover />

    <b-row class="">
      <b-col>
        <div class="alert-danger" v-show="errors.has('height')">
          <div v-if="errors.has('height')">
            {{ $t("validateErrors.noHeightSelected") }}
          </div>
        </div>
      </b-col>
    </b-row>
    <div class="content-column">
      <b-row
        ><b-col
          ><h3>{{ $t("header.columnType") }}</h3>
        </b-col></b-row
      >
      <b-row
        class="mt-3 mb-3"
        data-vv-name="active"
        v-validate="{ required: !activeColumn }"
      >
        <b-col
          md="6"
          lg="6"
          xl="3"
          @click="changeActive(columnType)"
          v-for="columnType in visibleColumnTypes"
          :key="columnType.id"
          class="d-flex align-items-stretch"
        >
          <b-card
            :class="{
              'selection-box': true,
              active: columnType.id == activeColumn,
            }"
          >
            <b-card-img
              :src="imageUrlForColumnType(columnType.id)"
              class="vcard-image"
            ></b-card-img>
            <div class="my-1">
              <h4 class="mt-2">{{ columnType.id }}</h4>
            </div>
            <div>
              {{ columnType.arableSites.length }}
              {{ $t("configuration.moduleSites") }}
            </div>
            <div>{{ columnType.widthX }} x {{ columnType.widthY }} mm</div>
            <div v-if="columnType.jibCrane">
              {{ $t("configuration.jibCranePossible") }}
            </div>
            <br />
            <div>
              <b-icon
                icon="info"
                style="width: 35px; height: 35px"
                class="p-1"
                variant="primary"
                :id="`popover-target-${columnType.id}`"
              ></b-icon>
              <b-popover
                :target="`popover-target-${columnType.id}`"
                triggers="hover"
                placement="top"
              >
                <template v-slot:title>{{ columnType.id }}</template>
                {{ columnType.description }}
              </b-popover>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row
        ><b-col
          ><h3>{{ $t("project.feeding.feedInPoint") }}</h3></b-col
        ></b-row
      >
      <b-row class="my-3 mb-4">
        <b-col v-for="option in visibleFeedIns" :key="option.value" md="4">
          <b-card
            :class="{
              'selection-box': true,
              active: option.value == feedInLocationCurrent,
            }"
            @click="changeActiveFeedInLocation(option)"
          >
            <b-card-img
              :src="require(`../assets/supply-options/${option.value}.png`)"
              top
              class="vcard-image small"
            />
            <h4 class="mt-2">{{ $t(option.text) }}</h4>
          </b-card>
        </b-col>
        <b-col md="4" lg="4" xl="3"> </b-col>
      </b-row>
      <b-row class="my-3"
        ><b-col
          ><h3>{{ $t("height") }}</h3></b-col
        ></b-row
      >
      <b-input-group append="mm" class="mb-5">
        <b-input
          id="base-height"
          v-model="height"
          type="number"
          step="125"
          @keypress="isNumber($event)"
          @change="checkHeight()"
          style="max-width: 150px"
        ></b-input>
      </b-input-group>
    </div>
    <b-modal
      id="change-column-configuration-modal"
      class="text-left"
      ref="dialog"
      :title="$t('configuration.editWarnings.irrevocableChanges')"
    >
      <span>{{ $t("configuration.editWarnings.modulesWillBeDeleted") }}</span>
      <template slot="modal-footer">
        <b-button @click="resetColumn()">{{ $t("cancel") }}</b-button>
        <b-button
          variant="danger"
          @click="
            saveColumn(null);
            $refs.dialog.hide();
          "
          >{{ $t("confirm") }}</b-button
        >
      </template>
    </b-modal>
  </div>
</template>

<script>
import ContactPopover from "../components/ContactPopover";
import { jibCraneSpan } from "../jibCrane";

export default {
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      feedInLocationCurrent: "MODULE",
      // Static settet do BOTTOM_UP because mounting is disabled
      mountingOrientation: "BOTTOM_UP",
      mountingMaterial: "CONCRETE",
      activeColumn: "",
      height: 1000
    };
  },
  components: {
    ContactPopover
  },
  created() {
    this.mountingOrientation = this.columnConfiguration.mountingOrientation;
    this.mountingMaterial = this.columnConfiguration.mountingMaterial;
    this.height = this.columnConfiguration.height;
    this.activeColumn = this.columnConfiguration.columnType;
    this.feedInCurrent = this.columnConfiguration.electricProtection
      ? this.columnConfiguration.electricProtection.feedInCurrent
      : 16;
    this.feedInLocationCurrent = this.columnConfiguration.feedInLocation;
  },
  computed: {
    visibleColumnTypes() {
      return [...this.$store.state.columnTypes].sort(function(a, b) {
        return a.widthY - b.widthY != 0 ? a.widthY - b.widthY : a.widthX - b.widthX;
      })
    },
    visibleFeedIns() {
      return [...this.feedInLocationOptions].sort(function(a, b) {
        return a.widthY - b.widthY;
      })
    },
    jibCraneSpan() {
      return jibCraneSpan();
    },
    feedInLocationOptions() {
      return [
        { value: "MODULE", text: this.$t("project.feeding.modules") },
        { value: "HEAD", text: this.$t("project.feeding.head") },
        { value: "BASEPLATE", text: this.$t("project.feeding.basePlate") }
      ];
    },
    modulePlacements: function() {
      return this.$store.state.configurations.configuration.modulePlacements
    },
    columnConfiguration() {
      if (this.$store.state.configurations.configuration !== null)
        return this.$store.state.configurations.configuration;
      return null;
    },

    allowedMinHeight() {
      let max =
        Math.max(
          ...this.modulePlacements.map(
            mp =>
              mp.position.gridIndex +
              this.moduleForSlot(mp.itemNumber).slotHeight
          )
        ) * 125;

      if (this.columnConfiguration.jibCrane) {
        return Math.max(
          max,
          this.columnConfiguration.jibCrane.height + this.jibCraneSpan
        );
      }
      return null;
    },
    columnType() {
      return this.$store.state.columnTypes.find(columnType => {
        return columnType.id == this.activeColumn;
      });
    }
  },
  methods: {
    resetColumn() {
      this.$refs.dialog.hide();
      this.activeColumn = this.columnConfiguration.columnType;
    },
    isNumber(evt) {
      const keysAllowed = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
      const keyPressed = evt.key;
      if (!keysAllowed.includes(keyPressed)) {
        evt.preventDefault();
      }
    },
    checkHeight() {
      if (this.height % 125 > 0) {
        this.height = (Math.floor(this.height / 125) + 1) * 125;
      }
      var minJibCraneHeight = 0;
      var jibCraneMinHeight = 0;
      if (this.columnConfiguration.jibCrane) {
        minJibCraneHeight = this.jibCraneSpan;

        jibCraneMinHeight =
          minJibCraneHeight + this.columnConfiguration.jibCrane.height;
      }

      const maxHeight = this.$store.state.columnTypes.find(type => type.id==this.activeColumn).maxHeight;
      if (this.height < 500) this.height = 500;
      if (this.height > maxHeight) this.height = maxHeight;

      if (this.height < jibCraneMinHeight) {
        this.height = (Math.floor(jibCraneMinHeight / 125) + 1) * 125;
      }

      this.changeConfigurationClick();
    },
    moduleForSlot(itemNumber) {
      const module = this.$store.state.modules.find(
        m => m.itemNumber == itemNumber
      );
      return module || null;
    },
    imageUrlForColumnType(id) {
      return `${process.env.VUE_APP_API}/column-types/${id}/image`;
    },

    changeConfigurationClick() {
      if (
        this.columnConfiguration != null &&
        this.columnConfiguration.columnType != this.activeColumn &&
        this.columnConfiguration.modulePlacements.length > 0
      ) {
        this.$refs.dialog.show();
      } else {
        this.saveColumn(
          this.$store.state.configurations.configuration &&
            this.$store.state.configurations.configuration.jibCrane
        );
      }
    },
    saveColumn: async function(jibCrane = null) {
      if (await this.$validator.validateAll()) {
        const changedModuleType =
          this.columnConfiguration.columnType !== this.activeColumn;
        if (!changedModuleType) {
          var calculatedNewModuleSlots = this.$store.state.configurations
            .configuration.modulePlacements
            ? this.$store.state.configurations.configuration.modulePlacements.filter(
                mp => {
                  return (
                    mp.position.gridIndex +
                      this.moduleForSlot(mp.itemNumber).slotHeight <=
                    this.height / 125
                  );
                }
              )
            : [];
        } else calculatedNewModuleSlots = [];

        this.$store.commit("configurations/setConfiguration", {
          configuration: {
            ...this.columnConfiguration,
            columnType: this.activeColumn,
            height: parseInt(this.height),
            mountingOrientation: this.mountingOrientation,
            mountingMaterial: this.mountingMaterial,
            jibCrane: this.columnType.jibCrane ? jibCrane : null,
            modulePlacements: calculatedNewModuleSlots,
            feedInLocation: this.feedInLocationCurrent
          }
        });
      }
    },
    changeActiveFeedInLocation(location) {
      this.feedInLocationCurrent = location.value;
      this.changeConfigurationClick();
    },
    changeActive(column) {
      if (!column.disabled) {
        this.activeColumn = column.id;
        this.checkHeight()
        this.changeConfigurationClick();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/common.scss";

#range-input {
  width: 80%;
}
.disabled {
  opacity: 0.4;
}
.vcard-image.small {
  height: 110px;
  width: auto;
}
.vcard-image {
  height: 150px;
  width: auto;
}

.label-and-questionmark {
  vertical-align: middle;
  display: flex;
}

.selection-box {
  width: 100%;
  text-align: center;
  cursor: pointer;
  box-shadow: 0 0 3px 1px #f0f0f0;
  margin-bottom: 30px;
}

.selection-box:hover {
  width: 100%;
  box-shadow: 0 0 4px 2px #e4e4e4;
  text-align: center;
}
.active.selection-box {
  z-index: 1;
  box-shadow: 0 0 0 4px $eepos-blue;
}

.form-label {
  margin: 0px 5px;
}
.form-icon {
  margin-right: 5px;
  color: grey;
}
.hr {
  width: 80%;
}

.content-column {
  flex-grow: 1;
  margin-top: auto;
  margin-bottom: auto;
}

.single-column:hover {
  background-color: rgb(230, 230, 230);
  transition: 0.5s;
}

.single-column {
  transition: 0.5s;
}
</style>
